import recaptcha from "./account/recaptcha";
import account from "./account/account";
import reCaptchaOnFocus from "./account/reCaptchaOnFocus";
import {ValidateEmail} from "./validators/indexValidator";

export default function kundservice() {
  account();
  recaptcha();
  $(function () {
    if ($("#twocolumns.kundservice").length === 0) {
      return;
    }
    
    if (document.getElementById('ddlWhereDidYouHear')) {
      document.getElementById('ddlWhereDidYouHear').addEventListener('focus', reCaptchaOnFocus, false);
    }
    
    function showSelectedContactUsForm(selectedOption) {
      const selectedFormId = selectedOption.val();
      const selectedForm = $("#" + selectedFormId);
      
      $(".forms-list-item-func").not(selectedForm).stop(true, true).slideUp(300);
      selectedForm.stop(true, true).slideDown(300);
      
      const sendButtonTitle = $(selectedOption).data("send-button-title");
      const $sendButton = $(".contact-us-btn-form-send-func");
      
      if (sendButtonTitle && sendButtonTitle.trim() !== '') {
        $sendButton.text(sendButtonTitle);
        $sendButton.data("form-id", selectedFormId);
        $sendButton.show();
      } else {
        $sendButton.text('');
        $sendButton.removeData("form-id");
        $sendButton.hide();
      }
      
      const formAcceptRedirectUrl = $(selectedOption).data("form-accept-redirect-url");
      
      if (formAcceptRedirectUrl && formAcceptRedirectUrl.trim() !== '') {
        $sendButton.data("form-accept-redirect-url", formAcceptRedirectUrl);
      } else {
        $sendButton.removeData("form-accept-redirect-url");
      }
    }
    
    const $ddlWhereDidYouHear = $('#ddlWhereDidYouHear');
    
    $ddlWhereDidYouHear.on('change', function () {
      const selectedOption = $(this).find("option:selected");
      
      showSelectedContactUsForm(selectedOption);
      
      if (selectedOption.data("redirect-url")) {
        $(this).find("option:first").prop('selected', true);
        document.location.href = selectedOption.data("redirect-url");
      }
    });
    
    const contactUsFormHash = window.location.hash.replace("#", "");
    
    if (contactUsFormHash) {
      const optionFromHash = $('#ddlWhereDidYouHear option[value="' + contactUsFormHash + '"]');
      
      if (optionFromHash.length > 0) {
        $ddlWhereDidYouHear.val(contactUsFormHash);
        showSelectedContactUsForm(optionFromHash);
        reCaptchaOnFocus();
      }
    } else {
      const selectedOption = $ddlWhereDidYouHear.find("option:selected");
      showSelectedContactUsForm(selectedOption);
    }
    
    $('#contact-us-form .contact-us-btn-form-send-func').on('click', function (e) {
      
      let captchaError = $("#spanCaptchaError");
      if (typeof (grecaptcha) == "undefined") {
        captchaError.show();
        captchaError.html("Please enable cookies for captcha to work");
        return;
      } else {
        captchaError.hide();
      }
      
      e.preventDefault()
      
      const formData = {};
      
      const formId = $(this).data('form-id');
      const formAcceptRedirectUrl = $(this).data('form-accept-redirect-url');
      
      const formElement = $("#" + formId);
      const formAcceptedMessageContainer = $("#formAcceptedMessage-" + formId);
      const formFields = formElement.find(".contact-us_form-element");
      let isValid = true;
      
      formFields.each((index, formFieldElement)=> {
        const $formField = $(formFieldElement)
        const fieldTitle = $formField.data("field-title");
        
        if (!fieldTitle) {
          return;
        }
        
        if (formData[fieldTitle] === undefined) {
          formData[fieldTitle] = {isRequired: false, labels: [], values: []};
        }
        
        const formInputId = $formField.prop('id');
        const $label = $('label[for="' + formInputId + '"]');
        const isRequired = $formField.data("is-optional") != null && $formField.data("is-optional") !== "True";
        formData[fieldTitle].labels.push($label);
        formData[fieldTitle].isRequired = isRequired;
        
        if ($formField.is(":checkbox") || $formField.is(":radio")) {
          
          if ($formField.is(":checked")) {
            formData[fieldTitle].values.push($formField.val());
          }
        } else {
          const value = $formField.val();
          
          if (value && value.trim() !== "") {
            formData[fieldTitle].values.push($formField.val());
          }
          
          if ($formField.data("is-email") === "True" && $formField.val() && $formField.val().trim() !== "") {
            formData.FormCustomerEmail = $formField.val();
          }
        }
      })
      
      const widgetId = window.ContactUsReCaptchaId;
      const captchaResult = grecaptcha.getResponse(widgetId);
      
      let formSendData = {};
      formSendData.FormName = $($ddlWhereDidYouHear.find("option:selected")).data("form-name");
      formSendData.Captcha = captchaResult
      formSendData.CustomerEmail = formData.FormCustomerEmail;
      formSendData.FormData = {};
      formSendData.CmsPagePath = $(".contact-us-btn-form-send-func").data("cms-page-path")
      
      for (let formDataKey in formData) {
        formSendData.FormData[formDataKey] = formData[formDataKey].values;
        
        if (formData[formDataKey].isRequired && formData[formDataKey].values.length === 0) {
          formData[formDataKey].labels.forEach(label => {
            $(label).addClass("form-input-error");
            isValid = false;
          })
        } else {
          formData[formDataKey].labels?.forEach(label => {
            $(label).removeClass("form-input-error");
          })
        }
      }
      
      if (!isValid) {
        return;
      }
      
      $.ajax({
        type: "POST",
        url: "/api/ContactUs/ContactUsDynamicForm",
        data: JSON.stringify(formSendData),
        contentType: "application/json",
        beforeSend: function () { $(".contact-us-btn-form-send-func").addClass("show-loader") },
        complete: function () { $(".contact-us-btn-form-send-func").removeClass("show-loader") },
        success: function (data) {
          if (data.Message && !data.IsSuccess) {
            captchaError.show();
            captchaError.html(data.Message);
          }
          
          if (data.IsSuccess) {
            const contactUsForm = $("#contact-us-form");
            captchaError.hide();
            $(formAcceptedMessageContainer).show();
            $("#spanContactUsError").hide();
            contactUsForm.hide("reset");
            
            if (formAcceptRedirectUrl && formAcceptRedirectUrl.trim() !== '') {
              window.location.href = formAcceptRedirectUrl;
            } else {
              window.scrollTo({
                top: 0,
                behavior: 'smooth'
              })
            }
          }
        },
        error: function (jqXHR, textStatus, errorThrown) {
          captchaError.show();
          captchaError.html(jqXHR.responseText);
        }
      });
      
      return;
      //Todo Remove bottom

      $("#spanContactUsMessage").hide();
      $("#spanContactUsError").hide();
      captchaError.hide();
      $("#contact-us-form .validator").hide();

      var object = {};
      object.Reason = $("#ddlWhereDidYouHear option:selected").val();
      object.ReasonText = $("#ddlWhereDidYouHear option:selected").text();
      object.Name = $("input[id$='tbxName']").val();
      object.Email = $("input[id$='tbxEmail']").val();
      object.OrderNumber = $("#tbxOrderNumber").val();
      object.Message = $("#tbxComment").val();;
      object.Captcha = captchaResult;

      var validArr = [];
      if (object.Reason == "Choose") {
        $("#rfvWhereDidYouHear").show();
        validArr.push(false);
      }
      if ((object.Reason == "MinOrder" || object.Reason == "Changes") && !object.OrderNumber) {
        $("#rfvOrderNumber").show();
        validArr.push(false);
      }
      if (!object.Name) {
        $("#rfvName").show();
        validArr.push(false);
      }
      if (!ValidateEmail($("input[id$='tbxEmail']"))) {
        validArr.push(false);
      }
      if (!object.Message) {
        $("#rfvComment").show();
        validArr.push(false);
    }

      if (validArr.length > 0) {
          return;
      }

      $.ajax({
        type: "POST",
        url: "/api/ContactUs",
        data: JSON.stringify(object),
        contentType: "application/json",
        beforeSend: function () { $("#contact-us-form #btnSend").addClass("show-loader") },
        complete: function () { $("#contact-us-form #btnSend").removeClass("show-loader") },
        error: function(jqXHR, textStatus, errorThrown) {
          captchaError.show();
          captchaError.html(jqXHR.responseText);
        },
        success: function (data) {
          grecaptcha.reset(widgetId);
          if (data.Message && !data.IsSuccess) {
            captchaError.show();
            captchaError.html(data.Message);
          } else if (!data.Message && !data.IsSuccess) {
            $("#spanContactUsMessage").hide();
            $("#spanContactUsError").show();
            $("#contact-us-form").hide();
          } else if (data.IsSuccess) {
            $("#spanContactUsMessage").show();
            $("#spanContactUsError").hide();
            $("#contact-us-form").hide();
            window.scrollTo({
              top: 0,
              behavior: 'smooth'
            })
          }
        }
      });
    });
  });
}
